import Layout from '@/layout/index.vue'

export const studentMap = {
  path: '/student',
  component: Layout,
  meta: { title: '学员', code: 856855 },
  children: [
    {
      path: 'student',
      component: () => import('@/views/student/student/index.vue'),
      meta: { title: '学员管理', code: 924941, drop: true },
      children: [
        {
          path: 'student',
          meta: { title: '学员管理', code: '' },
          component: () =>
            import('@/views/student/student/student/index.vue'),
          children: [
            {
              path: 'list',
              component: () =>
                import('@/views/student/student/student/list.vue'),
              meta: { title: '学员列表', keepAlive: true }
            },
            {
              path: 'add',
              component: () =>
                import('@/views/student/student/student/add.vue'),
              meta: { title: '添加学员', code: '' }
            },
            {
              path: 'edit',
              component: () =>
                import('@/views/student/student/student/add.vue'),
              meta: { title: '编辑学员', code: '' }
            },
            {
              path: 'detail',
              component: () =>
                import('@/views/student/student/student/add.vue'),
              meta: { title: '学员详情', code: '' }
            }
          ]
        }
      ]
    },
    {
      path: 'class',
      component: () => import('@/views/student/class/index.vue'),
      meta: { title: '班级管理', code: 916511, drop: true },
      children: [
        {
          path: 'class',
          component: () => import('@/views/student/class/class/index.vue'),
          meta: { title: '班级管理', code: '' },
          children: [
            {
              path: 'list',
              component: () => import('@/views/student/class/class/list.vue'),
              meta: { title: '班级列表', keepAlive: true }
            },
            {
              path: 'add',
              component: () => import('@/views/student/class/class/add.vue'),
              meta: { title: '添加班级', code: '' }
            },
            {
              path: 'edit',
              component: () => import('@/views/student/class/class/add.vue'),
              meta: { title: '编辑班级', code: '' }
            },
            {
              path: 'detail',
              component: () => import('@/views/student/class/class/add.vue'),
              meta: { title: '班级详情', code: '' }
            }
          ]
        },
        {
          path: 'group',
          component: () => import('@/views/student/class/group/index.vue'),
          meta: { title: '分组管理', code: 989001 },
          children: [
            {
              path: 'list',
              component: () => import('@/views/student/class/group/list.vue'),
              meta: { title: '分组列表', keepAlive: true }
            },
            {
              path: 'add',
              component: () => import('@/views/student/class/group/add.vue'),
              meta: { title: '添加分组', code: '' }
            },
            {
              path: 'edit',
              component: () => import('@/views/student/class/group/add.vue'),
              meta: { title: '编辑分组', code: '' }
            },
            {
              path: 'detail',
              component: () => import('@/views/student/class/group/add.vue'),
              meta: { title: '分组详情', code: '' }
            }
          ]
        }
      ]
    }
  ]
}
